import { Wallet, SlidersHorizontal, Globe2, ShieldCheck } from "lucide-react";

const TRADIES_IMG =
  "https://images.unsplash.com/photo-1646324554833-f0b6a479fa5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VyfGVufDB8fHx8MTc4NDY5MTU4MHww&ixlib=rb-4.1.0&q=85";

const reasons = [
  {
    icon: Wallet,
    title: "Cost-Effective",
    desc: "No office overheads or full-time salaries — just expert support when you need it.",
  },
  {
    icon: SlidersHorizontal,
    title: "Flexible Support",
    desc: "Scale services up or down to match your business as it grows and changes.",
  },
  {
    icon: Globe2,
    title: "Expertise Anywhere",
    desc: "Work with experienced NZ bookkeepers no matter where you're based.",
  },
  {
    icon: ShieldCheck,
    title: "Stay Compliant",
    desc: "Accurate books keep your GST, PAYE and statutory obligations met — no penalties, no audits.",
  },
];

function FeatureItem({ reason, index }) {
  const { icon: Icon, title, desc } = reason;
  return (
    <div
      data-testid={`why-card-${index}`}
      className="fade-up"
      style={{ animationDelay: `${0.08 * index}s` }}
    >
      <div className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-[#10BFCB]/15 mb-4">
        <Icon size={22} className="text-[#10BFCB]" />
      </div>
      <h3 className="font-heading text-xl font-medium mb-2">{title}</h3>
      <p className="text-white/75 leading-relaxed text-[15px]">{desc}</p>
    </div>
  );
}

export default function WhyChooseUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative py-24 lg:py-32 bg-[#10242B] text-white grain overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="relative">
            <div className="absolute -top-5 -left-5 w-full h-full rounded-md border-2 border-[#10BFCB] hidden sm:block" />
            <img
              src={TRADIES_IMG}
              alt="New Zealand tradie on a construction site"
              className="relative w-full h-[420px] object-cover rounded-md"
              loading="lazy"
            />
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-[#10BFCB]">
              Why Choose Us
            </h4>
            <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-semibold tracking-tight">
              Built for tradies & small businesses
            </h2>
            <p className="mt-5 text-lg text-white/80 max-w-xl">
              From building sites to storefronts, we understand the pace of real
              NZ business. We keep the numbers tidy so you can get on with the
              work that pays.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-6">
              {reasons.map((r, i) => (
                <FeatureItem key={r.title} reason={r} index={i} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
